export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';
export const COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME || 'prysm-registration';

console.log('[Config] Environment variables:', {
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    REACT_APP_COOKIE_NAME: process.env.REACT_APP_COOKIE_NAME,
    BACKEND_URL: BACKEND_URL,
    COOKIE_NAME: COOKIE_NAME,
    // AWS RUM Configuration
    AWS_RUM_APPLICATION_ID: process.env.REACT_APP_AWS_RUM_APPLICATION_ID ? 'configured' : 'not configured',
    AWS_RUM_REGION: process.env.REACT_APP_AWS_RUM_REGION || 'not configured',
    AWS_RUM_IDENTITY_POOL_ID: process.env.REACT_APP_AWS_RUM_IDENTITY_POOL_ID ? 'configured' : 'not configured',
    AWS_RUM_SAMPLE_RATE: process.env.REACT_APP_AWS_RUM_SAMPLE_RATE || 'not configured'
}); 